import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { MetricsTestimonialsSection } from './components/MetricsTestimonialsSection';
import { ExtendedTestimonialsSection } from './components/ExtendedTestimonialsSection';
import { PainSection } from './components/PainSection';
import { TransitionHookSection } from './components/TransitionHookSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { ProductShowcaseSection } from './components/ProductShowcaseSection';
import { ModulesSection } from './components/ModulesSection';
import { VipModuleSection } from './components/VipModuleSection';
import { BonusesSection } from './components/BonusesSection';
import { UrgencySection } from './components/UrgencySection';
import { PriceSection } from './components/PriceSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Montserrat:wght@400;600;700;800&family=Poppins:wght@400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    document.title = 'Mundial en el Aula 360™ | Planificación de 1.º a 7.º grado';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Transformá la pasión por el Mundial en aprendizaje. Planificación interdisciplinaria de 1.º a 7.º grado, actividades imprimibles y 4 bonos incluidos.');
  }, []);
  return <div className="font-sans text-familia-white bg-familia-bg min-h-screen selection:bg-familia-electric selection:text-familia-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <MetricsTestimonialsSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <ProductIntroSection data-id="element-4" />
      <ProductShowcaseSection data-id="element-5" />
      <VipModuleSection data-id="element-6" />
      <BonusesSection data-id="element-7" />
      <UrgencySection data-id="element-8" />
      <PriceSection data-id="element-9" />
      <ExtendedTestimonialsSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FaqSection data-id="element-12" />
      <ComparisonSection data-id="element-13" />
      <FinalCtaSection data-id="element-14" />
      <FooterSection data-id="element-15" />

      {/* Mobile Floating CTA */}
      
    </div>;
}